module.exports = __webpack_public_path__ + "img/2021_2_9_hairy_face.00cf7ad0.jpg";